import { Injectable } from "@angular/core";
import { AuthService } from 'src/app/core/services/auth.service';
import { ConfigService } from 'src/app/core/services/config.service';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AcademicHistoryDTO } from "../models/AcademicHistoryDTO";
import { switchMap } from "rxjs/operators";

@Injectable({ 
    providedIn: 'root'
})
export class AcademicHistoryService {
    private readonly apiUrl = ConfigService.settings.urls.apiUrl;
    private baseurl = "/applicationacademichistory/";
    private getSpecificUrl = this.apiUrl + this.baseurl + "byid/";    
    private deleteUrl = this.apiUrl + this.baseurl + "delete";    
    private updateUrl = this.apiUrl + this.baseurl + "update";
    private addUrl = this.apiUrl + this.baseurl + "add";    
    private getByApplicationUrl = this.apiUrl + this.baseurl + "byapplicationid/";
        
    constructor(protected httpClient: HttpClient,
        protected authService: AuthService) { }

    public get(id: number): Observable<AcademicHistoryDTO> {
        return this.httpClient.get<AcademicHistoryDTO>(this.getSpecificUrl + id);
    }
          
    public getAllByApplicationId(applicationId: number): Observable<AcademicHistoryDTO[]> {
        return this.httpClient.get<AcademicHistoryDTO[]>(this.getByApplicationUrl + applicationId);
        // return this.httpClient.get<AcademicHistoryDTO[]>(this.getByApplicationUrl + applicationId, { observe: 'response'}).pipe(
        //     switchMap(res => res.status === 200 ? of(res.body!) : of(undefined!))
        // );
    }

    public add(model: AcademicHistoryDTO): Observable<AcademicHistoryDTO> {
        return this.httpClient.post<AcademicHistoryDTO>(this.addUrl, model);
    }

    public update(model: AcademicHistoryDTO): Observable<AcademicHistoryDTO> {
        return this.httpClient.post<AcademicHistoryDTO>(this.updateUrl, model);
    }

    public delete(dto: AcademicHistoryDTO): Observable<AcademicHistoryDTO> {
        return this.httpClient.post<AcademicHistoryDTO>(this.deleteUrl, dto);
    }
}